<template>
  <div>
    <v-alert v-if="error" type="error" class="mb-0">
      {{ error }}
    </v-alert>

    <div class="d-flex justify-space-between align-center flex-wrap mb-4 gap-4">
      <v-card elevation="0" :loading="loading" class="flex-grow-1">
        <div class="pa-1">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busque por nome, organização ou plataforma"
            single-line
            outlined
            hide-details
            clearable
            dense
          />
        </div>
      </v-card>
      <v-btn-toggle v-model="viewType" mandatory color="primary">
        <v-btn
          v-for="item in viewTypes"
          :value="item.key"
          :key="item.key"
          small
        >
          <v-icon small left :color="item.key === viewType ? 'primary' : ''">
            {{ item.icon }}
          </v-icon>
          {{ item.name }}
        </v-btn>
      </v-btn-toggle>
    </div>

    <component
      :is="viewComponents[viewType]"
      :parties="filteredSort"
      :loading="loading"
      @update:filter="getParties"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PARTY from "@/services/admin/parties";
import PartyStatus from "@/utils/partyStatus";
import PartySort from "@/utils/partySortFunction";

import PartyCard from "@/components/admin/party/PartyCard.vue";
import PartiesMap from "../../components/admin/party/PartiesMap.vue";
import PartiesList from "../../components/admin/party/PartiesList.vue";
import PartiesCalendar from "../../components/admin/party/PartiesCalendar.vue";
export default {
  name: "Parties",
  metaInfo: {
    title: "Eventos",
  },
  components: {
    PartyCard,
    PartiesCalendar,
    PartiesList,
  },
  data: () => {
    return {
      loading: false,
      error: null,
      search: "",
      viewTypes: [
        {
          key: "list",
          name: "Lista",
          icon: "mdi-view-list",
        },
        {
          key: "calendar",
          name: "Calendário",
          icon: "mdi-calendar",
        },
        {
          key: "map",
          name: "Mapa",
          icon: "mdi-map",
        },
      ],
      viewComponents: {
        list: PartiesList,
        calendar: PartiesCalendar,
        map: PartiesMap,
      },
      viewType: null,
      partiesActive: [],
      partiesInactive: [],
    };
  },
  methods: {
    async getParties(act) {
      try {
        this.loading = true;
        this.error = null;

        const filter = act !== undefined ? act : this.filter;
        const active = filter === "active";

        if (active && this.partiesActive.length > 0) return;
        if (!active && this.partiesInactive.length > 0) return;

        const { parties } = await PARTY.getParties({ active });
        if (active) this.partiesActive = parties;
        else this.partiesInactive = parties;
      } catch (error) {
        console.log(error);
        this.error = error.message || "Erro ao buscar eventos";
      } finally {
        this.loading = false;
      }
    },
    filterParty(party) {
      if (!this.search) return true;

      return (
        party.name.toLowerCase().includes(this.search.toLowerCase()) ||
        party.Organization.name
          .toLowerCase()
          .includes(this.search.toLowerCase()) ||
        party.Organization.Platform.name
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },
  },

  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    filteredSort() {
      return {
        active: this.partiesActive.filter(this.filterParty).sort(PartySort),
        inactive: this.partiesInactive.filter(this.filterParty).sort(PartySort),
      };
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.partiesActive = [];
      this.partiesInactive = [];
      this.getParties("active");
    },
  },
  mounted() {
    this.getParties("active");
    if (this.$route.query.search) this.search = this.$route.query.search;
  },
};
</script>

<style></style>
